import {includes} from '@shared/helpers/collection'
import {someValueKeys} from '@shared/helpers/object'

import {getDeprecatedZipCodes, validateSelectedZipCodeAddress} from '@web/actions/deliveryInfo'
import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {DELIVERY_MEMO, DeliveryRecipient, OrderEntry, PickUpLocation} from '@web/core/constants'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import {isArrivalGuarantee} from '@web/helpers/policies'
import {NotAllowDirectReceiveBranchList} from '@web/slices/deliveryInfo/slice'
import makeSlice from '@web/slices/deliveryInfo/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {convertDeliveryAddress, getDeliveryAddressBookByApi} from '../../utils/apiHelper'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                const {data, isBranch} = payload
                if (!state.deliveryNothingOrder) {
                    if (!isBranch) {
                        const addressInfo = data.deliveryInfo.selected.addressInfo

                        state.selected.addressInfo = addressInfo
                    }
                    state.memo = data.deliveryInfo.memo
                    state.pickup = data.deliveryInfo.pickup
                    state.selected.recipient = data.deliveryInfo.selected.recipient
                } else {
                    /** 수신자 메모 복원 */
                    state.memo = data.deliveryInfo.memo
                }
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {deliveryNothingOrder, saleChannelType, modifyDeliveryPlaceByMerchantNo, products, branch} =
                    payload.data
                const {
                    defaultDeliveryAddress,
                    onVirtualPhoneNumber,
                    restrictedVirtualPhoneNumbers,
                    recentUsedDeliveryMemosReuse,
                } = payload.data.deliveryAddressBook ?? getDeliveryAddressBookByApi()

                state.deliveryNothingOrder = deliveryNothingOrder
                state.enabled =
                    saleChannelType !== OrderEntry.GIFTING ||
                    !someValueKeys((modifyDeliveryPlace) => !modifyDeliveryPlace, modifyDeliveryPlaceByMerchantNo ?? {})

                state.virtualPhoneNumber.onVirtualPhoneNumber = onVirtualPhoneNumber
                state.virtualPhoneNumber.restrictedVirtualPhoneNumbers = restrictedVirtualPhoneNumbers

                const memoList = recentUsedDeliveryMemosReuse.map(({memo, reuseMemo, template, memoSeq}) => {
                    return {
                        value: decode(memo),
                        reuse: reuseMemo,
                        template,
                        sequenceNumber: memoSeq,
                    }
                })
                state.memo.list = memoList

                // 메모 중 다음에도 사용할 메모가 있는 경우 통합메모에 초기화
                const memoToReuse = memoList?.find(({reuse}) => reuse)
                if (memoToReuse) {
                    state.memo.individuallyInput = {
                        type: memoToReuse.template ? DELIVERY_MEMO.COMMON : DELIVERY_MEMO.WRITTEN,
                        value: memoToReuse.value,
                    }
                    state.memo.saveAsDefaultMemo = true
                }

                const deliveryAddress = convertDeliveryAddress(defaultDeliveryAddress)

                state.hasArrivalGuaranteeProduct = products.some(({deliveryAttributeType}) =>
                    isArrivalGuarantee(deliveryAttributeType),
                )
                state.hasOverseasDeliveryProduct = payload.isOverseasDelivery

                state.hasDefaultAddress = deliveryAddress?.isPrimaryAddress ?? false
                state.selected.addressInfo = deliveryAddress

                // 저장된 수령방법이 직접 수령하기이면서, 직접수령하기를 허용하지 않는 장보기인 경우 장보기 수령방법을 저장하지 않음
                const directReceiveDisabled = includes(branch?.branchMarketType, NotAllowDirectReceiveBranchList)
                state.pickup.directReceiveDisabled = directReceiveDisabled
                const shouldResetPickup =
                    directReceiveDisabled && deliveryAddress?.locationType === PickUpLocation.DIRECT_RECEIVE

                if (!shouldResetPickup) {
                    if (deliveryAddress?.locationType) {
                        state.pickup.location.type = deliveryAddress.locationType
                        state.pickup.location.content = deliveryAddress.locationDescription ?? ''
                    }
                    if (deliveryAddress?.entryMethodType) {
                        state.pickup.entryMethod.type = deliveryAddress.entryMethodType
                        state.pickup.entryMethod.content = deliveryAddress.entryDescription ?? ''
                    }
                }

                state.pickup.alwaysUses = true

                if (saleChannelType === OrderEntry.GIFTING) {
                    state.selected.recipient = DeliveryRecipient.GIFT
                }
            })
            .addCase(getDeprecatedZipCodes.fulfilled, (state, {payload}) => {
                state.deprecatedZipCodes = payload
            })
            .addCase(validateSelectedZipCodeAddress.fulfilled, (state, {payload}) => {
                state.zipCodeValidation.validationFailType = payload.validationFailType
            })
    },
})

export default slice.reducer
